<template>
    <v-app>
        <Snackbar />
        <component v-bind:is="layout"></component>
    </v-app>
</template>
<script>
import AppLayout from "./layouts/AppLayout";
import SimpleLayout from "./layouts/SimpleLayout";
import Snackbar from "~/components/Snackbar";
import TokenService from "~/common/service.token";
import { CUSTOMER_CONFIG_KEY } from "~/config/constant";
import {CONFIG_PAGE} from "../store/actions.type";

export default {
    computed: {
        layout() {
            return this.$store.getters.common_layout;
        }
    },
    methods: {
        bindCustomerInfo() {
            var currentUser = TokenService.getUserInfo();
            if(currentUser && currentUser.config) {
                document.title = currentUser.config[CUSTOMER_CONFIG_KEY['WEB_TITLE']] ? currentUser.config[CUSTOMER_CONFIG_KEY['WEB_TITLE']] : 'AmaiTeam';
                var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = currentUser.config[CUSTOMER_CONFIG_KEY['FAV_ICON']] || '/images/logo.jpg';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
        },
        getAppName() {
            this.$store.dispatch(CONFIG_PAGE).then(data => {
                let appName = data.filter(o => o.key == 'key_cp_app_name');
                if (appName[0]['value'] != undefined && appName[0]['status']) {
                    this.appName = appName[0]['value'];
                    localStorage.setItem('appName', this.appName)
                }
            })
        }
    },
    created() {console.log('go in App.vue')
        this.bindCustomerInfo();
        this.getAppName();
    },
    components: {
        "app-layout": AppLayout,
        "simple-layout": SimpleLayout,
        Snackbar
    }
};
</script>
